<!-- SOLAPA «AGENTES»: el interruptor en la fila (guarda al toque); el resto, debajo de la fila. -->
<div class="space-y-6 pt-2">

  <div *ngIf="cargando" class="space-y-3" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-40 w-full rounded-xl"></div>
  </div>

  <div class="kb-tira" *ngIf="!cargando && error" role="alert">
    <p class="m-0 text-sm">
      <i class="fas fa-exclamation-circle mr-1.5 text-destructive" aria-hidden="true"></i>
      No se pudieron leer los agentes. <span class="text-muted-foreground">{{ error }}</span>
    </p>
    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="cargar()">
      <i class="fas fa-redo !text-foreground" aria-hidden="true"></i>Reintentar
    </button>
  </div>

  <section class="kb-tarjeta" *ngIf="!cargando && !error">
    <div class="kb-tarjeta-cab">
      <div>
        <h2 class="flex items-center gap-2 text-base font-semibold leading-none">
          <i class="fas fa-user-astronaut text-muted-foreground" aria-hidden="true"></i>Agentes
        </h2>
        <p class="m-0 mt-2 text-sm text-muted-foreground">
          El interruptor guarda al tocarlo. Para cambiar el modelo, el tope o las instrucciones, abre la fila.
        </p>
      </div>
    </div>
    <div class="kb-tarjeta-cuerpo">

      <div class="kb-empty" *ngIf="!agentes.length">
        <span class="kb-empty-icono"><i class="fas fa-user-astronaut" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">El servidor no devolvió ningún agente</p>
        <p class="kb-empty-texto">Tendría que listar al menos el asistente del comercio.</p>
      </div>

      <div class="kb-tabla-plana" *ngIf="agentes.length">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th w-16">Prendido</th>
              <th class="kb-th">Agente</th>
              <th class="kb-th">Modelo</th>
              <th class="kb-th kb-th-num">Tope diario</th>
              <th class="kb-th kb-th-num">Gasto de hoy</th>
              <th class="kb-th">Estado</th>
              <th class="kb-th w-10"><span class="sr-only">Abrir</span></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let a of agentes">
              <!-- 🔴 La fila NO es un botón (adentro hay un interruptor): el que abre los ajustes es
                   el nombre, un <button> con `aria-expanded`. El clic en la fila es para el ratón. -->
              <tr class="kb-tr kb-tr-clic" (click)="alternar(a)">
                <td class="kb-td">
                  <app-ia-interruptor [encendido]="a.habilitado" [deshabilitado]="!puedeEditar"
                                      [ocupado]="prendiendo === a.agente"
                                      [etiqueta]="(a.habilitado ? 'Apagar ' : 'Prender ') + tituloAgente(a.agente)"
                                      (cambiar)="prender(a, $event)"></app-ia-interruptor>
                </td>
                <td class="kb-td">
                  <button type="button" class="kb-td-titulo p-0 text-left hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50"
                          [attr.aria-expanded]="abierto === a.agente" [attr.aria-controls]="'ajustes-' + a.agente"
                          (click)="$event.stopPropagation(); alternar(a)">{{ tituloAgente(a.agente) }}</button>
                  <p class="kb-td-sub font-mono">{{ a.agente }}</p>
                  <p class="kb-td-sub max-w-md" *ngIf="queHaceAgente(a.agente)">{{ queHaceAgente(a.agente) }}</p>
                  <p class="kb-td-sub kb-texto-peligro" *ngIf="errorFila[a.agente]">{{ errorFila[a.agente] }}</p>
                </td>
                <td class="kb-td">{{ modeloEnUso(a) }}</td>
                <td class="kb-td kb-td-num whitespace-nowrap">{{ a.topeDiarioUsd !== null && a.topeDiarioUsd !== undefined ? usd(a.topeDiarioUsd) : 'El general' }}</td>
                <td class="kb-td kb-td-num whitespace-nowrap">{{ vivo(a) ? usd(vivo(a)?.gastoHoyUsd) : '—' }}</td>
                <td class="kb-td">
                  <span class="kb-badge kb-badge-neutro" *ngIf="!a.habilitado">
                    <i class="fas fa-pause-circle" aria-hidden="true"></i>Apagado</span>
                  <span class="kb-badge kb-badge-alerta" *ngIf="caido(a)">
                    <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>No está corriendo</span>
                  <span class="kb-badge kb-badge-exito" *ngIf="a.habilitado && vivo(a)?.operativo">
                    <i class="fas fa-check-circle" aria-hidden="true"></i>Corriendo</span>
                  <span class="text-sm text-muted-foreground" *ngIf="a.habilitado && !vivo(a)">—</span>
                  <p class="kb-td-sub kb-texto-alerta max-w-xs" *ngIf="caido(a) && vivo(a)?.ultimoError" [title]="vivo(a)?.ultimoError || ''">{{ errorDeProveedor(vivo(a)?.ultimoError) }}</p>
                </td>
                <td class="kb-td">
                  <i class="fas fa-chevron-right text-xs text-muted-foreground transition-transform"
                     [class.rotate-90]="abierto === a.agente" aria-hidden="true"></i>
                </td>
              </tr>

              <!-- Los ajustes, debajo de la fila. -->
              <tr *ngIf="abierto === a.agente" [id]="'ajustes-' + a.agente">
                <td class="kb-td kb-fondo-suave" colspan="7">
                  <form class="grid gap-4 py-2 md:grid-cols-3" (ngSubmit)="guardar(a)">
                    <div>
                      <label class="kb-label" [attr.for]="'ag-modelo-' + a.agente">Modelo</label>
                      <div class="kb-select-envoltorio">
                        <select class="kb-select" [id]="'ag-modelo-' + a.agente" name="modeloId"
                                [(ngModel)]="form.modeloId" [disabled]="!puedeEditar">
                          <option value="">El modelo por omisión{{ estado?.modeloPorOmision ? ' (' + nombreModelo(estado?.modeloPorOmision) + ')' : '' }}</option>
                          <option *ngIf="modeloFueraDeCatalogo()" [value]="form.modeloId">{{ form.modeloId }}</option>
                          <option *ngFor="let m of catalogo" [value]="m.id">{{ m.nombre }} · {{ usd(m.precioEntrada) }} / {{ usd(m.precioSalida) }} por millón</option>
                        </select>
                        <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div>
                      <label class="kb-label" [attr.for]="'ag-tope-' + a.agente">Tope diario propio, en dólares</label>
                      <input class="kb-input" type="number" min="0" step="0.01" inputmode="decimal"
                             [id]="'ag-tope-' + a.agente" name="topeDiarioUsd" [(ngModel)]="form.topeDiarioUsd"
                             [disabled]="!puedeEditar" placeholder="Vacío: usa el tope general">
                    </div>
                    <div>
                      <label class="kb-label" [attr.for]="'ag-tokens-' + a.agente">Máximo de tokens por llamada</label>
                      <input class="kb-input" type="number" min="50" max="8000" step="1" inputmode="numeric"
                             [id]="'ag-tokens-' + a.agente" name="maxTokens" [(ngModel)]="form.maxTokens"
                             [disabled]="!puedeEditar" [class.kb-input-invalido]="!formValido">
                      <p class="kb-hint">Entre 50 y 8.000.</p>
                    </div>
                    <div class="md:col-span-3">
                      <label class="kb-label" [attr.for]="'ag-prompt-' + a.agente">Instrucciones adicionales</label>
                      <textarea class="kb-textarea" rows="4" [id]="'ag-prompt-' + a.agente" name="promptExtra"
                                [(ngModel)]="form.promptExtra" [disabled]="!puedeEditar"
                                placeholder="Se suman a las instrucciones de fábrica de este agente."></textarea>
                      <p class="kb-hint">No cambian las reglas: el asistente sólo ve el comercio de la sesión, diga lo que diga aquí.</p>
                    </div>
                    <div class="flex flex-wrap items-center gap-3 md:col-span-3">
                      <button type="submit" class="kb-btn kb-btn-primary" *ngIf="puedeEditar"
                              [disabled]="guardando || !formValido">
                        <i class="fas" [ngClass]="guardando ? 'fa-circle-notch fa-spin' : 'fa-save'" aria-hidden="true"></i>Guardar los ajustes
                      </button>
                      <button type="button" class="kb-btn kb-btn-ghost" (click)="abierto = null">Cerrar</button>
                      <p class="m-0 text-sm" *ngIf="resultado" role="status"
                         [ngClass]="resultado.ok ? 'kb-texto-exito' : 'kb-texto-peligro'">{{ resultado.texto }}</p>
                      <p class="m-0 ml-auto text-xs text-muted-foreground" *ngIf="esFechaReal(a.updatedAt)">
                        Último cambio: {{ fechaHora(a.updatedAt) }}{{ a.actualizadoPor ? ' · ' + a.actualizadoPor : '' }}
                      </p>
                    </div>
                  </form>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</div>
